// Build-time feature flags.
//
// PRICING_PAGE_ENABLED gates the Premium pricing/checkout page AND every link
// to it, so the route and its discoverability can never drift apart: with it
// false, /pricing renders NotFoundPage like any unknown path and the footer
// link is not rendered at all.
//
// It is false because real money is involved and the EU consumer-law work is
// not finished - there is no /terms page, no pre-payment acknowledgement of the
// 14-day withdrawal right, and the trader identity details are still
// placeholders in docs/legal/drafts/. See
// docs/legal/2026-10-26-premium-checkout-gate-review.md.
//
// Turned on by the owner on 2026-10-26, with that work still outstanding and
// the risk stated. Turning it off again is this one line.
export const PRICING_PAGE_ENABLED = true;
